import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f1481b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-sm-12" }
const _hoisted_8 = { class: "nav" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Personal Infromation")
  ])
], -1))
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-sm-6 box" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Name", -1))
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "First name", -1))
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Middle name", -1))
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "form-group mb-3" }
const _hoisted_22 = { class: "form-check" }
const _hoisted_23 = ["checked"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "form-middlenameCheck"
}, "I certify that I do not have Middle Name on my official identification document.", -1))
const _hoisted_25 = { class: "mb-3" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Last name", -1))
const _hoisted_27 = ["value"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mt-5" }, "Current Mailing Address", -1))
const _hoisted_29 = { class: "mb-3" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "State", -1))
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "mb-3" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Street Address", -1))
const _hoisted_34 = ["value"]
const _hoisted_35 = { class: "mb-3" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "City", -1))
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "mb-3" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Zip Code", -1))
const _hoisted_40 = ["value"]
const _hoisted_41 = { class: "mb-3" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Start Living Date", -1))
const _hoisted_43 = ["value"]
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mt-5" }, "Contact Information", -1))
const _hoisted_45 = { class: "mb-3" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Phone", -1))
const _hoisted_47 = ["value"]
const _hoisted_48 = { class: "mb-3" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Ext", -1))
const _hoisted_50 = ["value"]
const _hoisted_51 = { class: "mb-3" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Email", -1))
const _hoisted_53 = ["value"]
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mt-5" }, "Identification", -1))
const _hoisted_55 = { class: "mb-3" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Date of Birth", -1))
const _hoisted_57 = ["value"]
const _hoisted_58 = { class: "mb-3" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "SSN", -1))
const _hoisted_60 = ["value"]
const _hoisted_61 = { class: "form-group mb-3" }
const _hoisted_62 = { class: "form-check" }
const _hoisted_63 = ["checked"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "form-middlenameCheck"
}, "I don't have a Social Security Number.", -1))
const _hoisted_65 = { class: "mb-3" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Country of Birth", -1))
const _hoisted_67 = ["value"]
const _hoisted_68 = { class: "mb-3" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Country of Citizenship", -1))
const _hoisted_70 = ["value"]
const _hoisted_71 = { class: "col-sm-6" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-5" }, "Personal Infromation is approved?", -1))
const _hoisted_73 = { class: "form-check mb-3" }
const _hoisted_74 = ["disabled"]
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios1"
}, " Yes ", -1))
const _hoisted_76 = { class: "form-check mb-3" }
const _hoisted_77 = ["disabled"]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios2"
}, " No ", -1))
const _hoisted_79 = { class: "mb-3" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlTextarea1",
  class: "form-label"
}, "Reason", -1))
const _hoisted_81 = ["disabled"]
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Canidate Self-Reported Information")
  ])
], -1))
const _hoisted_83 = { class: "row" }
const _hoisted_84 = { class: "col-sm-6" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 1. In the last & years have you ever been convicted of. Or pleaded guilty or no contest to, a felony crime, excluding 1) any offense for which you were adjudicated as a juvenile, or 2) convictions which have been expunged or sealed by a court? ", -1))
const _hoisted_86 = { class: "d-flex" }
const _hoisted_87 = { class: "form-check mb-3" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios1"
}, " Yes ", -1))
const _hoisted_89 = { class: "form-check mb-3 ms-3" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios2"
}, " No ", -1))
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 2. In the last 7 years, have you ever been convicted of, or pleaded guilty or no contest to, a misdemeanor crime, excluding 1) any offense for which you were adjudicated as a juvenile (age 17 and under), or 2) any driving related office like DUI, Reckless Driving, Negligent Driving etc.3) any misdemeanor drug convictions over the 2 years. ", -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Please note that while it is advised that you do not have to disclose these convictions, they will be reported and may be considered in the overall context of your background check screening. ", -1))
const _hoisted_93 = { class: "d-flex" }
const _hoisted_94 = { class: "form-check mb-3" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios1"
}, " Yes ", -1))
const _hoisted_96 = { class: "form-check mb-3 ms-3" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios2"
}, " No ", -1))
const _hoisted_98 = { class: "col-sm-6" }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-5" }, "Self Reported Information is approved?", -1))
const _hoisted_100 = { class: "form-check mb-3" }
const _hoisted_101 = ["disabled"]
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios1"
}, " Yes ", -1))
const _hoisted_103 = { class: "form-check mb-3" }
const _hoisted_104 = ["disabled"]
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios2"
}, " No ", -1))
const _hoisted_106 = { class: "mb-3" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlTextarea1",
  class: "form-label"
}, "Reason", -1))
const _hoisted_108 = ["disabled"]
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Charges or Violation of Law")
  ])
], -1))
const _hoisted_110 = { class: "row" }
const _hoisted_111 = { class: "col-sm-6" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Are you currently under charges for any law violation? ", -1))
const _hoisted_113 = { class: "d-flex" }
const _hoisted_114 = { class: "form-check mb-3" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios1"
}, " Yes ", -1))
const _hoisted_116 = { class: "form-check mb-3 ms-3" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios2"
}, " No ", -1))
const _hoisted_118 = { class: "d-flex mb-3" }
const _hoisted_119 = { class: "me-3" }
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "form-crime_occurance_date-input"
}, "Date of occurance", -1))
const _hoisted_121 = ["value"]
const _hoisted_122 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "form-crime_city-input"
}, "City", -1))
const _hoisted_123 = ["value"]
const _hoisted_124 = { class: "me-3" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "form-crime_explanation-input"
}, "Explanation", -1))
const _hoisted_126 = ["value"]
const _hoisted_127 = { class: "col-sm-6" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-5" }, " Charges or Violation of Law Information is approved? ", -1))
const _hoisted_129 = { class: "form-check mb-3" }
const _hoisted_130 = ["disabled"]
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios1"
}, " Yes ", -1))
const _hoisted_132 = { class: "form-check mb-3" }
const _hoisted_133 = ["disabled"]
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios2"
}, " No ", -1))
const _hoisted_135 = { class: "mb-3" }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlTextarea1",
  class: "form-label"
}, "Reason", -1))
const _hoisted_137 = ["disabled"]
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Education History")
  ])
], -1))
const _hoisted_139 = { class: "row" }
const _hoisted_140 = { class: "col-sm-6" }
const _hoisted_141 = { class: "col-sm-6" }
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-5" }, "Education History is approved?", -1))
const _hoisted_143 = { class: "form-check mb-3" }
const _hoisted_144 = ["disabled"]
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios1"
}, " Yes ", -1))
const _hoisted_146 = { class: "form-check mb-3" }
const _hoisted_147 = ["disabled"]
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios2"
}, " No ", -1))
const _hoisted_149 = { class: "mb-3" }
const _hoisted_150 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlTextarea1",
  class: "form-label"
}, "Reason", -1))
const _hoisted_151 = ["disabled"]
const _hoisted_152 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Employment History")
  ])
], -1))
const _hoisted_153 = { class: "row" }
const _hoisted_154 = { class: "col-sm-6" }
const _hoisted_155 = { class: "col-sm-6" }
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-5" }, "Employment History is approved?", -1))
const _hoisted_157 = { class: "form-check mb-3" }
const _hoisted_158 = ["disabled"]
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios1"
}, " Yes ", -1))
const _hoisted_160 = { class: "form-check mb-3" }
const _hoisted_161 = ["disabled"]
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios2"
}, " No ", -1))
const _hoisted_163 = { class: "mb-3" }
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlTextarea1",
  class: "form-label"
}, "Reason", -1))
const _hoisted_165 = ["disabled"]
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Address History")
  ])
], -1))
const _hoisted_167 = { class: "row" }
const _hoisted_168 = { class: "col-sm-6" }
const _hoisted_169 = { class: "col-sm-6" }
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-5" }, "Address History is approved?", -1))
const _hoisted_171 = { class: "form-check mb-3" }
const _hoisted_172 = ["disabled"]
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios1"
}, " Yes ", -1))
const _hoisted_174 = { class: "form-check mb-3" }
const _hoisted_175 = ["disabled"]
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios2"
}, " No ", -1))
const _hoisted_177 = { class: "mb-3" }
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlTextarea1",
  class: "form-label"
}, "Reason", -1))
const _hoisted_179 = ["disabled"]
const _hoisted_180 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12" }, [
    /*#__PURE__*/_createElementVNode("h3", null, "Screening Disclosure and Authorization")
  ])
], -1))
const _hoisted_181 = { class: "row" }
const _hoisted_182 = { class: "col-sm-6" }
const _hoisted_183 = ["src"]
const _hoisted_184 = { class: "form-group mb-3" }
const _hoisted_185 = { class: "form-check" }
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "I certify that the signature I have drawn is my signature.", -1))
const _hoisted_187 = { class: "mb-3" }
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "firstname-input1"
}, "Full name", -1))
const _hoisted_189 = { class: "mb-5" }
const _hoisted_190 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-label",
  for: "email-input1"
}, "E-mail", -1))
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " SwiftIdentity sends a copy of the signed document to the email address above. Please ensure the email address is correct. ", -1))
const _hoisted_192 = { class: "form-group mb-3" }
const _hoisted_193 = { class: "form-check" }
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, " I certify that I am the person identified. My clicking the “Accept & Continue button constitutes my electronic signature to this document. ", -1))
const _hoisted_195 = { class: "form-group mb-3" }
const _hoisted_196 = { class: "form-check" }
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-check-label" }, "I understand that I am using electronic means to sign this document. I have reviewed the electronic signature disclosure, and I consent to signing these documents and disclosures electronically. ", -1))
const _hoisted_198 = { class: "col-sm-6" }
const _hoisted_199 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-5" }, " Screening Disclosure and Authorization is approved? ", -1))
const _hoisted_200 = { class: "form-check mb-3" }
const _hoisted_201 = ["disabled"]
const _hoisted_202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios1"
}, " Yes ", -1))
const _hoisted_203 = { class: "form-check mb-3" }
const _hoisted_204 = ["disabled"]
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios2"
}, " No ", -1))
const _hoisted_206 = { class: "mb-3" }
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlTextarea1",
  class: "form-label"
}, "Reason", -1))
const _hoisted_208 = ["disabled"]
const _hoisted_209 = {
  key: 0,
  class: "d-flex justify-content-end"
}
const _hoisted_210 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_211 = ["disabled"]
const _hoisted_212 = ["disabled"]
const _hoisted_213 = { class: "row" }
const _hoisted_214 = { class: "col-sm-12" }
const _hoisted_215 = /*#__PURE__*/_createTextVNode(" Photo Match Status: ")
const _hoisted_216 = {
  key: 0,
  class: "table"
}
const _hoisted_217 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { colspan: "2" }, "Metadata"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1))
const _hoisted_218 = { scope: "row" }
const _hoisted_219 = { class: "row mb-3" }
const _hoisted_220 = { class: "col-sm-6 box" }
const _hoisted_221 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Document Type", -1))
const _hoisted_222 = { class: "mb-3" }
const _hoisted_223 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Document Type", -1))
const _hoisted_224 = ["value"]
const _hoisted_225 = { class: "col-sm-6" }
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-5" }, "Document Type is approved?", -1))
const _hoisted_227 = { class: "form-check mb-3" }
const _hoisted_228 = ["disabled"]
const _hoisted_229 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios1"
}, " Yes ", -1))
const _hoisted_230 = { class: "form-check mb-3" }
const _hoisted_231 = ["disabled"]
const _hoisted_232 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios2"
}, " No ", -1))
const _hoisted_233 = { class: "mb-3" }
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlTextarea1",
  class: "form-label"
}, "Reason", -1))
const _hoisted_235 = ["disabled"]
const _hoisted_236 = { class: "row mb-3" }
const _hoisted_237 = { class: "col-sm-6" }
const _hoisted_238 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Official Doc Front", -1))
const _hoisted_239 = { class: "dropzone" }
const _hoisted_240 = ["src", "alt"]
const _hoisted_241 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-file-image" })
], -1))
const _hoisted_242 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Official Doc Front Preview", -1))
const _hoisted_243 = { class: "col-sm-6" }
const _hoisted_244 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-5" }, "Official Doc Front is approved?", -1))
const _hoisted_245 = { class: "form-check mb-3" }
const _hoisted_246 = ["disabled"]
const _hoisted_247 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios1"
}, " Yes ", -1))
const _hoisted_248 = { class: "form-check mb-3" }
const _hoisted_249 = ["disabled"]
const _hoisted_250 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios2"
}, " No ", -1))
const _hoisted_251 = { class: "mb-3" }
const _hoisted_252 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlTextarea1",
  class: "form-label"
}, "Reason", -1))
const _hoisted_253 = ["disabled"]
const _hoisted_254 = { class: "row mb-3" }
const _hoisted_255 = { class: "col-sm-6" }
const _hoisted_256 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Official Doc Back", -1))
const _hoisted_257 = { class: "dropzone" }
const _hoisted_258 = ["src", "alt"]
const _hoisted_259 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-file-image" })
], -1))
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Official Doc Back Preview", -1))
const _hoisted_261 = { class: "col-sm-6" }
const _hoisted_262 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-5" }, "Official Doc Back is approved?", -1))
const _hoisted_263 = { class: "form-check mb-3" }
const _hoisted_264 = ["disabled"]
const _hoisted_265 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios1"
}, " Yes ", -1))
const _hoisted_266 = { class: "form-check mb-3" }
const _hoisted_267 = ["disabled"]
const _hoisted_268 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios2"
}, " No ", -1))
const _hoisted_269 = { class: "mb-3" }
const _hoisted_270 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlTextarea1",
  class: "form-label"
}, "Reason", -1))
const _hoisted_271 = ["disabled"]
const _hoisted_272 = { class: "row mb-3" }
const _hoisted_273 = { class: "col-sm-6" }
const _hoisted_274 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Selfie Image", -1))
const _hoisted_275 = { class: "dropzone" }
const _hoisted_276 = ["src", "alt"]
const _hoisted_277 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-file-image" })
], -1))
const _hoisted_278 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, "Selfie Image Preview", -1))
const _hoisted_279 = { class: "col-sm-6" }
const _hoisted_280 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "fs-5" }, "Selfie Image is approved?", -1))
const _hoisted_281 = { class: "form-check mb-3" }
const _hoisted_282 = ["disabled"]
const _hoisted_283 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios1"
}, " Yes ", -1))
const _hoisted_284 = { class: "form-check mb-3" }
const _hoisted_285 = ["disabled"]
const _hoisted_286 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "formRadios2"
}, " No ", -1))
const _hoisted_287 = { class: "mb-3" }
const _hoisted_288 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "exampleFormControlTextarea1",
  class: "form-label"
}, "Reason", -1))
const _hoisted_289 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EducationHistory = _resolveComponent("EducationHistory")!
  const _component_EmploymentHistory = _resolveComponent("EmploymentHistory")!
  const _component_AddressHistory = _resolveComponent("AddressHistory")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("ul", _hoisted_8, [
                  _createElementVNode("li", {
                    class: "nav-item",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tab = 1))
                  }, [
                    _createElementVNode("h2", {
                      class: _normalizeClass(_ctx.tab == 1 ? 'nav-link active' : 'nav-link')
                    }, " Connected Form ", 2)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_ctx.tab == 1)
              ? (_openBlock(), _createElementBlock("form", {
                  key: 0,
                  method: "POST",
                  onSubmit: _cache[35] || (_cache[35] = (e) => e.preventDefault())
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("div", _hoisted_15, [
                          _hoisted_16,
                          _createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            value: _ctx.form.first_name,
                            readonly: ""
                          }, null, 8, _hoisted_17)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _hoisted_19,
                          _createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            value: _ctx.form.middle_name,
                            readonly: ""
                          }, null, 8, _hoisted_20)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              class: "form-check-input",
                              checked: _ctx.form.no_middle_name,
                              disabled: ""
                            }, null, 8, _hoisted_23),
                            _hoisted_24
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            value: _ctx.form.last_name,
                            readonly: ""
                          }, null, 8, _hoisted_27)
                        ]),
                        _hoisted_28,
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            value: _ctx.form.state,
                            readonly: ""
                          }, null, 8, _hoisted_31)
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _hoisted_33,
                          _createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            value: _ctx.form.street_address,
                            readonly: ""
                          }, null, 8, _hoisted_34)
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            value: _ctx.form.city,
                            readonly: ""
                          }, null, 8, _hoisted_37)
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            value: _ctx.form.zip_code,
                            readonly: ""
                          }, null, 8, _hoisted_40)
                        ]),
                        _createElementVNode("div", _hoisted_41, [
                          _hoisted_42,
                          _createElementVNode("input", {
                            type: "month",
                            class: "form-control",
                            value: _ctx.getMonth(_ctx.form.start_living_date),
                            readonly: ""
                          }, null, 8, _hoisted_43)
                        ]),
                        _hoisted_44,
                        _createElementVNode("div", _hoisted_45, [
                          _hoisted_46,
                          _createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            value: _ctx.form.phone,
                            readonly: ""
                          }, null, 8, _hoisted_47)
                        ]),
                        _createElementVNode("div", _hoisted_48, [
                          _hoisted_49,
                          _createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            value: _ctx.form.ext,
                            readonly: ""
                          }, null, 8, _hoisted_50)
                        ]),
                        _createElementVNode("div", _hoisted_51, [
                          _hoisted_52,
                          _createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            value: _ctx.form.email,
                            readonly: ""
                          }, null, 8, _hoisted_53)
                        ]),
                        _hoisted_54,
                        _createElementVNode("div", _hoisted_55, [
                          _hoisted_56,
                          _createElementVNode("input", {
                            type: "date",
                            class: "form-control",
                            value: _ctx.form.date_of_birth,
                            readonly: ""
                          }, null, 8, _hoisted_57)
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          _hoisted_59,
                          _createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            value: _ctx.form.SSN,
                            readonly: ""
                          }, null, 8, _hoisted_60)
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              class: "form-check-input",
                              checked: _ctx.form.no_ssn,
                              disabled: ""
                            }, null, 8, _hoisted_63),
                            _hoisted_64
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _hoisted_66,
                          _createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            value: _ctx.form.birth_country,
                            readonly: ""
                          }, null, 8, _hoisted_67)
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          _hoisted_69,
                          _createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            value: _ctx.form.citizenship_country,
                            readonly: ""
                          }, null, 8, _hoisted_70)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _hoisted_72,
                        _createElementVNode("div", _hoisted_73, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.review.personal_info) = $event)),
                            value: true,
                            disabled: _ctx.reviewDisable
                          }, null, 8, _hoisted_74), [
                            [_vModelRadio, _ctx.review.personal_info]
                          ]),
                          _hoisted_75
                        ]),
                        _createElementVNode("div", _hoisted_76, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.review.personal_info) = $event)),
                            value: false,
                            disabled: _ctx.reviewDisable
                          }, null, 8, _hoisted_77), [
                            [_vModelRadio, _ctx.review.personal_info]
                          ]),
                          _hoisted_78
                        ]),
                        _createElementVNode("div", _hoisted_79, [
                          _hoisted_80,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "form-control",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.review.desc_personal_info) = $event)),
                            disabled: _ctx.reviewDisable,
                            id: "exampleFormControlTextarea1",
                            rows: "8"
                          }, null, 8, _hoisted_81), [
                            [_vModelText, _ctx.review.desc_personal_info]
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_82,
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _hoisted_85,
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("div", _hoisted_87, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.self_reported_one) = $event)),
                              value: true,
                              disabled: ""
                            }, null, 512), [
                              [_vModelRadio, _ctx.form.self_reported_one]
                            ]),
                            _hoisted_88
                          ]),
                          _createElementVNode("div", _hoisted_89, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.self_reported_one) = $event)),
                              value: false,
                              disabled: ""
                            }, null, 512), [
                              [_vModelRadio, _ctx.form.self_reported_one]
                            ]),
                            _hoisted_90
                          ])
                        ]),
                        _hoisted_91,
                        _hoisted_92,
                        _createElementVNode("div", _hoisted_93, [
                          _createElementVNode("div", _hoisted_94, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.self_reported_two) = $event)),
                              value: true,
                              disabled: ""
                            }, null, 512), [
                              [_vModelRadio, _ctx.form.self_reported_two]
                            ]),
                            _hoisted_95
                          ]),
                          _createElementVNode("div", _hoisted_96, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.self_reported_two) = $event)),
                              value: false,
                              disabled: ""
                            }, null, 512), [
                              [_vModelRadio, _ctx.form.self_reported_two]
                            ]),
                            _hoisted_97
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_98, [
                        _hoisted_99,
                        _createElementVNode("div", _hoisted_100, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.review.self_reported_info) = $event)),
                            value: true,
                            disabled: _ctx.reviewDisable
                          }, null, 8, _hoisted_101), [
                            [_vModelRadio, _ctx.review.self_reported_info]
                          ]),
                          _hoisted_102
                        ]),
                        _createElementVNode("div", _hoisted_103, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.review.self_reported_info) = $event)),
                            value: false,
                            disabled: _ctx.reviewDisable
                          }, null, 8, _hoisted_104), [
                            [_vModelRadio, _ctx.review.self_reported_info]
                          ]),
                          _hoisted_105
                        ]),
                        _createElementVNode("div", _hoisted_106, [
                          _hoisted_107,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "form-control",
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.review.desc_self_reported_info) = $event)),
                            disabled: _ctx.reviewDisable,
                            id: "exampleFormControlTextarea1",
                            rows: "8"
                          }, null, 8, _hoisted_108), [
                            [_vModelText, _ctx.review.desc_self_reported_info]
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_109,
                    _createElementVNode("div", _hoisted_110, [
                      _createElementVNode("div", _hoisted_111, [
                        _hoisted_112,
                        _createElementVNode("div", _hoisted_113, [
                          _createElementVNode("div", _hoisted_114, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              disabled: "",
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.law_violation) = $event)),
                              value: true
                            }, null, 512), [
                              [_vModelRadio, _ctx.form.law_violation]
                            ]),
                            _hoisted_115
                          ]),
                          _createElementVNode("div", _hoisted_116, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              disabled: "",
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.law_violation) = $event)),
                              value: false
                            }, null, 512), [
                              [_vModelRadio, _ctx.form.law_violation]
                            ]),
                            _hoisted_117
                          ])
                        ]),
                        (_ctx.form.law_violation)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("div", _hoisted_118, [
                                _createElementVNode("div", _hoisted_119, [
                                  _hoisted_120,
                                  _createElementVNode("input", {
                                    type: "date",
                                    class: "form-control",
                                    id: "form-crime_occurance_date-input",
                                    readonly: "",
                                    value: _ctx.form.crime_occurance_date
                                  }, null, 8, _hoisted_121)
                                ]),
                                _createElementVNode("div", null, [
                                  _hoisted_122,
                                  _createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "form-crime_city-input",
                                    readonly: "",
                                    value: _ctx.form.crime_city
                                  }, null, 8, _hoisted_123)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_124, [
                                _hoisted_125,
                                _createElementVNode("textarea", {
                                  class: "form-control",
                                  id: "form-crime_explanation-input",
                                  rows: "10",
                                  readonly: "",
                                  value: _ctx.form.crime_explanation
                                }, null, 8, _hoisted_126)
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_127, [
                        _hoisted_128,
                        _createElementVNode("div", _hoisted_129, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.review.crimincal_history) = $event)),
                            value: true,
                            disabled: _ctx.reviewDisable
                          }, null, 8, _hoisted_130), [
                            [_vModelRadio, _ctx.review.crimincal_history]
                          ]),
                          _hoisted_131
                        ]),
                        _createElementVNode("div", _hoisted_132, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.review.crimincal_history) = $event)),
                            value: false,
                            disabled: _ctx.reviewDisable
                          }, null, 8, _hoisted_133), [
                            [_vModelRadio, _ctx.review.crimincal_history]
                          ]),
                          _hoisted_134
                        ]),
                        _createElementVNode("div", _hoisted_135, [
                          _hoisted_136,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "form-control",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.review.desc_crimincal_history) = $event)),
                            disabled: _ctx.reviewDisable,
                            id: "exampleFormControlTextarea1",
                            rows: "8"
                          }, null, 8, _hoisted_137), [
                            [_vModelText, _ctx.review.desc_crimincal_history]
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_138,
                    _createElementVNode("div", _hoisted_139, [
                      _createElementVNode("div", _hoisted_140, [
                        _createVNode(_component_EducationHistory, {
                          disable: true,
                          isReview: true
                        })
                      ]),
                      _createElementVNode("div", _hoisted_141, [
                        _hoisted_142,
                        _createElementVNode("div", _hoisted_143, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.review.education_history) = $event)),
                            value: true,
                            disabled: _ctx.reviewDisable
                          }, null, 8, _hoisted_144), [
                            [_vModelRadio, _ctx.review.education_history]
                          ]),
                          _hoisted_145
                        ]),
                        _createElementVNode("div", _hoisted_146, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.review.education_history) = $event)),
                            value: false,
                            disabled: _ctx.reviewDisable
                          }, null, 8, _hoisted_147), [
                            [_vModelRadio, _ctx.review.education_history]
                          ]),
                          _hoisted_148
                        ]),
                        _createElementVNode("div", _hoisted_149, [
                          _hoisted_150,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "form-control",
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.review.desc_education_history) = $event)),
                            disabled: _ctx.reviewDisable,
                            id: "exampleFormControlTextarea1",
                            rows: "8"
                          }, null, 8, _hoisted_151), [
                            [_vModelText, _ctx.review.desc_education_history]
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_152,
                    _createElementVNode("div", _hoisted_153, [
                      _createElementVNode("div", _hoisted_154, [
                        _createVNode(_component_EmploymentHistory, {
                          disable: true,
                          isReview: true
                        })
                      ]),
                      _createElementVNode("div", _hoisted_155, [
                        _hoisted_156,
                        _createElementVNode("div", _hoisted_157, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.review.employment_history) = $event)),
                            value: true,
                            disabled: _ctx.reviewDisable
                          }, null, 8, _hoisted_158), [
                            [_vModelRadio, _ctx.review.employment_history]
                          ]),
                          _hoisted_159
                        ]),
                        _createElementVNode("div", _hoisted_160, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.review.employment_history) = $event)),
                            value: false,
                            disabled: _ctx.reviewDisable
                          }, null, 8, _hoisted_161), [
                            [_vModelRadio, _ctx.review.employment_history]
                          ]),
                          _hoisted_162
                        ]),
                        _createElementVNode("div", _hoisted_163, [
                          _hoisted_164,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "form-control",
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.review.desc_employment_history) = $event)),
                            disabled: _ctx.reviewDisable,
                            id: "exampleFormControlTextarea1",
                            rows: "8"
                          }, null, 8, _hoisted_165), [
                            [_vModelText, _ctx.review.desc_employment_history]
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_166,
                    _createElementVNode("div", _hoisted_167, [
                      _createElementVNode("div", _hoisted_168, [
                        _createVNode(_component_AddressHistory, {
                          disable: true,
                          isReview: true
                        })
                      ]),
                      _createElementVNode("div", _hoisted_169, [
                        _hoisted_170,
                        _createElementVNode("div", _hoisted_171, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.review.address_history) = $event)),
                            value: true,
                            disabled: _ctx.reviewDisable
                          }, null, 8, _hoisted_172), [
                            [_vModelRadio, _ctx.review.address_history]
                          ]),
                          _hoisted_173
                        ]),
                        _createElementVNode("div", _hoisted_174, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.review.address_history) = $event)),
                            value: false,
                            disabled: _ctx.reviewDisable
                          }, null, 8, _hoisted_175), [
                            [_vModelRadio, _ctx.review.address_history]
                          ]),
                          _hoisted_176
                        ]),
                        _createElementVNode("div", _hoisted_177, [
                          _hoisted_178,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "form-control",
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.review.desc_address_history) = $event)),
                            disabled: _ctx.reviewDisable,
                            id: "exampleFormControlTextarea1",
                            rows: "8"
                          }, null, 8, _hoisted_179), [
                            [_vModelText, _ctx.review.desc_address_history]
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_180,
                    _createElementVNode("div", _hoisted_181, [
                      _createElementVNode("div", _hoisted_182, [
                        (_ctx.screenPdfSrc)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.screenPdfSrc,
                              alt: "Image Signature",
                              class: "img-fluid-kyc"
                            }, null, 8, _hoisted_183))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_184, [
                          _createElementVNode("div", _hoisted_185, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              class: "form-check-input",
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.screeningDisclouser.my_signature) = $event)),
                              disabled: ""
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.screeningDisclouser.my_signature]
                            ]),
                            _hoisted_186
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_187, [
                          _hoisted_188,
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.screeningDisclouser.first_name) = $event)),
                            disabled: ""
                          }, null, 512), [
                            [_vModelText, _ctx.screeningDisclouser.first_name]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_189, [
                          _hoisted_190,
                          _withDirectives(_createElementVNode("input", {
                            type: "email",
                            class: "form-control",
                            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.screeningDisclouser.email) = $event)),
                            disabled: ""
                          }, null, 512), [
                            [_vModelText, _ctx.screeningDisclouser.email]
                          ])
                        ]),
                        _hoisted_191,
                        _createElementVNode("div", _hoisted_192, [
                          _createElementVNode("div", _hoisted_193, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              class: "form-check-input",
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.screeningDisclouser.accept_electronic_sign) = $event)),
                              disabled: ""
                            }, null, 512), [
                              [_vModelCheckbox, _ctx.screeningDisclouser.accept_electronic_sign]
                            ]),
                            _hoisted_194
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_195, [
                          _createElementVNode("div", _hoisted_196, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              class: "form-check-input",
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((
                              _ctx.screeningDisclouser.accpet_personal_identification
                            ) = $event)),
                              disabled: ""
                            }, null, 512), [
                              [_vModelCheckbox, 
                              _ctx.screeningDisclouser.accpet_personal_identification
                            ]
                            ]),
                            _hoisted_197
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_198, [
                        _hoisted_199,
                        _createElementVNode("div", _hoisted_200, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.review.screening_disclosure) = $event)),
                            value: true,
                            disabled: _ctx.reviewDisable
                          }, null, 8, _hoisted_201), [
                            [_vModelRadio, _ctx.review.screening_disclosure]
                          ]),
                          _hoisted_202
                        ]),
                        _createElementVNode("div", _hoisted_203, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "radio",
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.review.screening_disclosure) = $event)),
                            value: false,
                            disabled: _ctx.reviewDisable
                          }, null, 8, _hoisted_204), [
                            [_vModelRadio, _ctx.review.screening_disclosure]
                          ]),
                          _hoisted_205
                        ]),
                        _createElementVNode("div", _hoisted_206, [
                          _hoisted_207,
                          _withDirectives(_createElementVNode("textarea", {
                            class: "form-control",
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.review.desc_screening_disclosure) = $event)),
                            disabled: _ctx.reviewDisable,
                            id: "exampleFormControlTextarea1",
                            rows: "8"
                          }, null, 8, _hoisted_208), [
                            [_vModelText, _ctx.review.desc_screening_disclosure]
                          ])
                        ])
                      ])
                    ]),
                    (_ctx.roles.admin)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_209, [
                          _createVNode(_component_router_link, {
                            to: { name: 'admin-form-submission' },
                            class: "btn btn-secondary w-md me-2"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_210
                            ]),
                            _: 1
                          }),
                          (_ctx.allApproved)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.submit(true))),
                                type: "submit",
                                class: "btn btn-primary w-md",
                                disabled: _ctx.reviewDisable
                              }, " Complete Review ", 8, _hoisted_211))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.submit(false))),
                                type: "submit",
                                class: "btn btn-danger w-md me-2",
                                disabled: _ctx.reviewDisable
                              }, " Decline Form ", 8, _hoisted_212))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 32))
              : _createCommentVNode("", true),
            (_ctx.tab == 2 && _ctx.form.kyc)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_213, [
                    _createElementVNode("div", _hoisted_214, [
                      _createElementVNode("h4", null, [
                        _hoisted_215,
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", _ctx.form.kyc.photo_verified ? 'badge-info' : 'badge-danger'])
                        }, _toDisplayString(_ctx.form.kyc.photo_verified ? "Matched" : "Not matched"), 3)
                      ]),
                      (_ctx.form.kyc.doc_metadata)
                        ? (_openBlock(), _createElementBlock("table", _hoisted_216, [
                            _hoisted_217,
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.metadata), (key) => {
                                return (_openBlock(), _createElementBlock("tr", { key: key }, [
                                  _createElementVNode("td", _hoisted_218, _toDisplayString(key), 1),
                                  _createElementVNode("td", null, _toDisplayString(_ctx.metadata[key]), 1)
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_219, [
                    _createElementVNode("div", _hoisted_220, [
                      _hoisted_221,
                      _createElementVNode("div", _hoisted_222, [
                        _hoisted_223,
                        _createElementVNode("input", {
                          type: "text",
                          class: "form-control",
                          value: _ctx.docTypes[_ctx.form.kyc.doc_type],
                          readonly: ""
                        }, null, 8, _hoisted_224)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_225, [
                      _hoisted_226,
                      _createElementVNode("div", _hoisted_227, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "radio",
                          "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.kycReview.doc_type) = $event)),
                          value: true,
                          disabled: _ctx.reviewDisable
                        }, null, 8, _hoisted_228), [
                          [_vModelRadio, _ctx.kycReview.doc_type]
                        ]),
                        _hoisted_229
                      ]),
                      _createElementVNode("div", _hoisted_230, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "radio",
                          "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.kycReview.doc_type) = $event)),
                          value: false,
                          disabled: _ctx.reviewDisable
                        }, null, 8, _hoisted_231), [
                          [_vModelRadio, _ctx.kycReview.doc_type]
                        ]),
                        _hoisted_232
                      ]),
                      _createElementVNode("div", _hoisted_233, [
                        _hoisted_234,
                        _withDirectives(_createElementVNode("textarea", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.kycReview.desc_doc_type) = $event)),
                          disabled: _ctx.reviewDisable,
                          id: "exampleFormControlTextarea1",
                          rows: "8"
                        }, null, 8, _hoisted_235), [
                          [_vModelText, _ctx.kycReview.desc_doc_type]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_236, [
                    _createElementVNode("div", _hoisted_237, [
                      _hoisted_238,
                      _createElementVNode("div", _hoisted_239, [
                        (_ctx.form.kyc.official_doc)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.form.kyc.official_doc.src,
                              alt: _ctx.form.kyc.official_doc.alt_text,
                              class: "img-fluid-kyc"
                            }, null, 8, _hoisted_240))
                          : _createCommentVNode("", true),
                        (!_ctx.form.kyc.official_doc)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_241,
                              _hoisted_242
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_243, [
                      _hoisted_244,
                      _createElementVNode("div", _hoisted_245, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "radio",
                          "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.kycReview.official_doc) = $event)),
                          value: true,
                          disabled: _ctx.reviewDisable
                        }, null, 8, _hoisted_246), [
                          [_vModelRadio, _ctx.kycReview.official_doc]
                        ]),
                        _hoisted_247
                      ]),
                      _createElementVNode("div", _hoisted_248, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "radio",
                          "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.kycReview.official_doc) = $event)),
                          value: false,
                          disabled: _ctx.reviewDisable
                        }, null, 8, _hoisted_249), [
                          [_vModelRadio, _ctx.kycReview.official_doc]
                        ]),
                        _hoisted_250
                      ]),
                      _createElementVNode("div", _hoisted_251, [
                        _hoisted_252,
                        _withDirectives(_createElementVNode("textarea", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.kycReview.desc_official_doc) = $event)),
                          disabled: _ctx.reviewDisable,
                          id: "exampleFormControlTextarea1",
                          rows: "8"
                        }, null, 8, _hoisted_253), [
                          [_vModelText, _ctx.kycReview.desc_official_doc]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_254, [
                    _createElementVNode("div", _hoisted_255, [
                      _hoisted_256,
                      _createElementVNode("div", _hoisted_257, [
                        (_ctx.form.kyc.official_doc_back)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.form.kyc.official_doc_back.src,
                              alt: _ctx.form.kyc.official_doc_back.alt_text,
                              class: "img-fluid-kyc"
                            }, null, 8, _hoisted_258))
                          : _createCommentVNode("", true),
                        (!_ctx.form.kyc.official_doc_back)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_259,
                              _hoisted_260
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_261, [
                      _hoisted_262,
                      _createElementVNode("div", _hoisted_263, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "radio",
                          "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.kycReview.official_doc_back) = $event)),
                          value: true,
                          disabled: _ctx.reviewDisable
                        }, null, 8, _hoisted_264), [
                          [_vModelRadio, _ctx.kycReview.official_doc_back]
                        ]),
                        _hoisted_265
                      ]),
                      _createElementVNode("div", _hoisted_266, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "radio",
                          "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.kycReview.official_doc_back) = $event)),
                          value: false,
                          disabled: _ctx.reviewDisable
                        }, null, 8, _hoisted_267), [
                          [_vModelRadio, _ctx.kycReview.official_doc_back]
                        ]),
                        _hoisted_268
                      ]),
                      _createElementVNode("div", _hoisted_269, [
                        _hoisted_270,
                        _withDirectives(_createElementVNode("textarea", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.kycReview.desc_official_doc_back) = $event)),
                          disabled: _ctx.reviewDisable,
                          id: "exampleFormControlTextarea1",
                          rows: "8"
                        }, null, 8, _hoisted_271), [
                          [_vModelText, _ctx.kycReview.desc_official_doc_back]
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_272, [
                    _createElementVNode("div", _hoisted_273, [
                      _hoisted_274,
                      _createElementVNode("div", _hoisted_275, [
                        (_ctx.form.kyc.live_photo)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.form.kyc.live_photo.src,
                              alt: _ctx.form.kyc.live_photo.alt_text,
                              class: "img-fluid-kyc"
                            }, null, 8, _hoisted_276))
                          : _createCommentVNode("", true),
                        (!_ctx.form.kyc.live_photo)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _hoisted_277,
                              _hoisted_278
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_279, [
                      _hoisted_280,
                      _createElementVNode("div", _hoisted_281, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "radio",
                          "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.kycReview.live_photo) = $event)),
                          value: true,
                          disabled: _ctx.reviewDisable
                        }, null, 8, _hoisted_282), [
                          [_vModelRadio, _ctx.kycReview.live_photo]
                        ]),
                        _hoisted_283
                      ]),
                      _createElementVNode("div", _hoisted_284, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "radio",
                          "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.kycReview.live_photo) = $event)),
                          value: false,
                          disabled: _ctx.reviewDisable
                        }, null, 8, _hoisted_285), [
                          [_vModelRadio, _ctx.kycReview.live_photo]
                        ]),
                        _hoisted_286
                      ]),
                      _createElementVNode("div", _hoisted_287, [
                        _hoisted_288,
                        _withDirectives(_createElementVNode("textarea", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.kycReview.desc_live_photo) = $event)),
                          disabled: _ctx.reviewDisable,
                          id: "exampleFormControlTextarea1",
                          rows: "8"
                        }, null, 8, _hoisted_289), [
                          [_vModelText, _ctx.kycReview.desc_live_photo]
                        ])
                      ])
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}